const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Fashion Shopper, New York",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20with%20blonde%20hair%20on%20soft%20sage%20green%20gradient%20background%2C%20warm%20studio%20lighting%2C%20friendly%20smile%2C%20editorial%20headshot%20style%2C%20natural%20professional%20look&width=100&height=100&seq=avt-v2-sarah&orientation=squarish",
    rating: 5,
    text: "The mulebuy spreadsheet system completely changed how I organize my agent purchases. Everything is tracked transparently, and I never have to wonder about hidden fees. Truly a game-changer for anyone serious about shopping smarter.",
  },
  {
    name: "James Rodriguez",
    role: "Regular Buyer, London",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20man%20portrait%20with%20short%20dark%20hair%20on%20warm%20terracotta%20gradient%20background%2C%20soft%20studio%20lighting%2C%20confident%20expression%2C%20editorial%20headshot%20style%2C%20clean%20professional%20look&width=100&height=100&seq=avt-v2-james&orientation=squarish",
    rating: 5,
    text: "I was skeptical about the mulebuy spreadsheet approach at first, but after using it for three months, I cannot imagine going back. The comparison tables and structured format save me hours every week.",
  },
  {
    name: "Emily Chen",
    role: "Sneaker Collector, Toronto",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20portrait%20with%20long%20dark%20hair%20on%20soft%20lavender%20gradient%20background%2C%20warm%20studio%20lighting%2C%20bright%20smile%2C%20editorial%20headshot%20style%2C%20modern%20professional%20look&width=100&height=100&seq=avt-v2-emily&orientation=squarish",
    rating: 5,
    text: "Finding limited sneakers through mulebuy spreadsheet has been incredibly efficient. The organized layout makes comparing sizes, prices, and shipping options so much easier than any other platform I have tried.",
  },
  {
    name: "David Park",
    role: "Streetwear Enthusiast, Seoul",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20man%20portrait%20on%20soft%20mint%20green%20gradient%20background%2C%20warm%20studio%20lighting%2C%20friendly%20calm%20expression%2C%20editorial%20headshot%20style%2C%20casual%20professional%20look&width=100&height=100&seq=avt-v2-david&orientation=squarish",
    rating: 4,
    text: "The mulebuy spreadsheet guide helped me understand the entire agent shopping process from start to finish. Now I manage all my streetwear purchases through the spreadsheet format and it keeps everything perfectly organized.",
  },
  {
    name: "Olivia Brown",
    role: "Fashion Blogger, Sydney",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20with%20curly%20brown%20hair%20on%20soft%20peach%20gradient%20background%2C%20warm%20studio%20lighting%2C%20radiant%20smile%2C%20editorial%20headshot%20style%2C%20fashionable%20professional%20look&width=100&height=100&seq=avt-v2-olivia&orientation=squarish",
    rating: 5,
    text: "As someone who orders dozens of items monthly, the mulebuy spreadsheet system is a lifesaver. The structured approach means I always know exactly where each order stands, from purchase to delivery.",
  },
  {
    name: "Michael Torres",
    role: "Reseller, Miami",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20man%20portrait%20with%20styled%20hair%20on%20soft%20amber%20gradient%20background%2C%20warm%20studio%20lighting%2C%20confident%20approachable%20expression%2C%20editorial%20headshot%20style%2C%20modern%20professional%20look&width=100&height=100&seq=avt-v2-michael&orientation=squarish",
    rating: 5,
    text: "For bulk ordering and reselling, nothing beats the mulebuy spreadsheet format. The ability to compare multiple items side-by-side with transparent pricing makes my business run so much smoother than before.",
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="w-2 h-2 bg-accent-400 rounded-full"></span>
              <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">User Reviews</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 leading-tight">
              Trusted by Shoppers<br />Worldwide
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              See what real users say about their experience with the mulebuy spreadsheet system.
            </p>
          </div>

          {/* Testimonial Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/60"
              >
                {/* Stars */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, starIdx) => (
                    <i
                      key={starIdx}
                      className={`text-sm ${
                        starIdx < t.rating
                          ? "ri-star-fill text-amber-400"
                          : "ri-star-line text-foreground-300"
                      }`}
                    ></i>
                  ))}
                </div>

                {/* Title */}
                <h4 className="font-heading text-base font-semibold text-foreground-950 mb-3">
                  {t.rating === 5 ? "Excellent Experience" : "Great System"}
                </h4>

                {/* Review Text */}
                <p className="text-sm leading-relaxed mb-5 text-foreground-600">
                  {t.text}
                </p>

                {/* User Info */}
                <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-400">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}